import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-240bb4bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "art" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, " Film Fotografie ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Click a tile to view full-size photo", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Plenty more pics coming eventually", -1))
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "art-modal-content" }
const _hoisted_7 = { class: "art-modal-progress arial" }
const _hoisted_8 = { class: "modal-nav" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "art-modal-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arial" }, "ID: ", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = ["alt", "src"]
const _hoisted_16 = { class: "art-content" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["alt", "src"]
const _hoisted_20 = ["src"]

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ref } from 'vue'
import data from '@/assets/photo/photo.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'FotoView',
  setup(__props) {

const now = new Date()
const isoDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7).toISOString().substring(0,10)

const modalVisibility = ref(false)
const modalIndex = ref(0)

const toggleModal = (i: number) => {
	if (!modalVisibility.value) {
		modalIndex.value = i
	}
	modalVisibility.value = !modalVisibility.value
}

const showModal = (i: number, name: string) => {
	// window.dataLayer.push({'event': 'click_art_tile', 'artTitle': name});
	toggleModal(i)
}

const modalNewer = () => {
	if (modalIndex.value > 0) {
		modalIndex.value--
	}
}
const modalOlder = () => {
	if (modalIndex.value < data.length-1) {
		modalIndex.value++
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["art-body", modalVisibility.value ? 'fixed' : ''])
    }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      (modalVisibility.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "art-modal",
            id: 'modal-'+modalIndex.value
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, " Viewing " + _toDisplayString(modalIndex.value+1) + " of " + _toDisplayString(_unref(data).length), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: _normalizeClass(["modal-nav-button arrow", modalIndex.value > 0 ? '' : 'disabled']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (modalNewer())),
                  alt: "view newer image"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-left" }),
                    _createTextVNode(" newer ")
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["modal-nav-button arrow", modalIndex.value < _unref(data).length-1 ? '' : 'disabled']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (modalOlder())),
                  alt: "view older image"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(" older "),
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevron-right" })
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: "modal-nav-button close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleModal(modalIndex.value))),
                  alt: "close"
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-xmark" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_unref(data)[modalIndex.value].id), 1)
              ]),
              _createElementVNode("a", {
                href: require('@/assets/photo/photos/' + _unref(data)[modalIndex.value].filename),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  class: "art-modal-img",
                  alt: _unref(data)[modalIndex.value].id,
                  src: require('@/assets/photo/photos/' + _unref(data)[modalIndex.value].filename)
                }, null, 8, _hoisted_15)
              ], 8, _hoisted_14)
            ])
          ], 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (photo, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createElementVNode("div", {
              class: "art-tile",
              onClick: ($event: any) => {showModal(i, photo.id);}
            }, [
              _createElementVNode("img", {
                class: "art-tile-spinner",
                alt: "spinner",
                src: require('@/assets/spinner.gif')
              }, null, 8, _hoisted_18),
              _createElementVNode("img", {
                class: "art-tile-img",
                alt: photo.id,
                src: require('@/assets/photo/thumbs/' + photo.filename)
              }, null, 8, _hoisted_19),
              (photo.date > _unref(isoDate))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "art-tile-new",
                    alt: "new",
                    src: require('@/assets/art/icons/new.gif')
                  }, null, 8, _hoisted_20))
                : _createCommentVNode("", true)
            ], 8, _hoisted_17)
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}
}

})